import { configureStore } from '@reduxjs/toolkit'
import previewReducer from './slices/previewSlice'
import rootReducer from '../redux/rootReducer'

export const store = configureStore({
  reducer: rootReducer,
  // Middleware ve devTools buraya eklenir
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store 